import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi } from "@/lib/adminAuth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/admin", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const r = await adminApi.post(
          "/auth/google",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        // Save token to localStorage as a fallback in case cross-site
        // cookie is blocked (e.g., strict browser settings).
        if (r.data && r.data.session_token) {
          localStorage.setItem("pyp_admin_token", r.data.session_token);
        } else {
          // Re-fetch /auth/me to verify cookie session works
          try {
            const me = await adminApi.get("/auth/me");
            if (!me.data) throw new Error("no session");
          } catch {
            // fallback: nothing to do
          }
        }
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { justSignedIn: true } });
      } catch (e) {
        const msg =
          e?.response?.data?.detail ||
          "Sign-in failed. This account isn't authorized for admin access.";
        navigate("/admin", { replace: true, state: { authError: msg } });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center text-white">
      <div className="text-center">
        <p className="font-display text-4xl uppercase">Signing You In…</p>
        <p className="mt-4 text-zinc-500 font-mono text-xs tracking-widest uppercase">
          Securing session
        </p>
      </div>
    </div>
  );
}
